import ReactSelect, { SingleValue } from "react-select";
import { ReactSelectStyles, FlexBox } from "@styles";
import styled from "styled-components";
import React from "react";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
  DropdownSection,
  DropdownHeading,
} from "@components/Catalyst/dropdown";

import { ChevronDownIcon, CheckIcon } from "@heroicons/react/16/solid";

export interface PaletteOption {
  readonly value: string;
  readonly label: string;
  readonly disabled?: boolean;
}

export interface GroupedPaletteOption {
  readonly label: string;
  readonly options: readonly PaletteOption[];
}

const BadgeStyle = styled.span`
  background-color: #ebecf0;
  border-radius: 50%;
  color: #172b4d;
  font-size: 12px;
  padding: 2px 5px;
`;

const formatGroupLabel = (group: GroupedPaletteOption) => (
  <FlexBox alignItems="center" justifyContent="space-between" color="#12b8f6">
    <span>{group.label}</span>
    <BadgeStyle>{group.options.length}</BadgeStyle>
  </FlexBox>
);

export const PaletteSelector = ({
  groupedPaletteOptions,
  defaultValue,
  onChange,
}: {
  groupedPaletteOptions: GroupedPaletteOption[];
  defaultValue: PaletteOption;
  onChange: (newValue: PaletteOption | null) => void;
}) => (
  <ReactSelect<PaletteOption, false, GroupedPaletteOption>
    options={groupedPaletteOptions}
    styles={ReactSelectStyles}
    value={defaultValue}
    formatGroupLabel={formatGroupLabel}
    isOptionDisabled={(option) => option.disabled ?? false}
    onChange={(newValue: SingleValue<PaletteOption>) => onChange(newValue)}
  />
);

export const CatalystPaletteSelector = ({
  groupedPaletteOptions,
  defaultValue,
  onChange,
}: {
  groupedPaletteOptions: GroupedPaletteOption[];
  defaultValue: string;
  onChange: (newValue: string) => void;
}) => (
  <Dropdown>
    <DropdownButton outline>
      Filter
      <ChevronDownIcon />
    </DropdownButton>
    <DropdownMenu>
      {groupedPaletteOptions.map(
        (group) =>
          group.options.length > 0 && (
            <DropdownSection aria-label="Account" key={group.label}>
              <DropdownHeading>{group.label}</DropdownHeading>

              {group.options.map((option) => (
                <DropdownItem key={option.value} onClick={() => onChange(option.value)}>
                  {defaultValue === option.value && <CheckIcon />}
                  <DropdownLabel>{option.label}</DropdownLabel>
                </DropdownItem>
              ))}
            </DropdownSection>
          ),
      )}
    </DropdownMenu>
  </Dropdown>
);
